import { render, staticRenderFns } from "./codeInput.vue?vue&type=template&id=70c343d7&scoped=true&"
import script from "./codeInput.vue?vue&type=script&lang=js&"
export * from "./codeInput.vue?vue&type=script&lang=js&"
import style0 from "./codeInput.vue?vue&type=style&index=0&id=70c343d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c343d7",
  null
  
)

export default component.exports